interface StatsCardProps {
    icon: string;
    value: number | string;
    label: string;
    highlight?: boolean;
}

export default function StatsCard({ icon, value, label, highlight = false }: StatsCardProps) {
    return (
        <div className={`stat-card ${highlight ? 'border-2 border-primary-500' : ''}`}>
            <span className="text-2xl mb-2">{icon}</span>
            <span className={`text-3xl font-bold ${highlight ? 'text-primary-600' : 'text-gray-900'}`}>
                {value}
            </span>
            <span className="text-sm text-gray-500 mt-1">{label}</span>
        </div>
    );
}
